import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Wdata from "./Wdata";
import "./Works.css";

const Works = () => {
  const { t } = useTranslation();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const handleClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prevIndex) => (prevIndex === 0 ? Wdata.length - 1 : prevIndex - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prevIndex) => (prevIndex === Wdata.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <section className="works">
      <div className="container">
        <div className="heading">
          <h1>{t("retreats")}</h1>
          <div className="line"></div>
        </div>

        <div className="gallery">
          {Wdata.map((item, index) => (
            <div className="thumbnail" key={item.id} onClick={() => handleClick(index)}>
              <img src={item.cover} alt="menu_thumbnail" />
            </div>
          ))}
        </div>

        {selectedImageIndex !== null && (
          <div className="modal" onClick={() => setSelectedImageIndex(null)}>
            <div className="modal-content">
              <button className="prev" onClick={handlePrev}>&#10094;</button>
              <img src={Wdata[selectedImageIndex].cover} alt="selected_menu" />
              <button className="next" onClick={handleNext}>&#10095;</button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Works;
